@if (html) {
  <div
    class="inner-html"
    [ngClass]="{ 'no-links': !allowLinks }"
    [ngClass]="{ center: center }"
    (click)="processLinks($event)"
    [innerHtml]="html | sanitizeHtml"
  ></div>
}
